import { TransactionFilterParams } from '@/types/filters';

/**
 * Clean filter parameters by removing undefined, null, and empty string values.
 * This prevents sending invalid parameters to the backend API.
 */
export const cleanFilterParams = (filters?: TransactionFilterParams): Record<string, any> => {
  if (!filters) return {};
  
  const clean: Record<string, any> = {};
  
  if (filters.txType) clean.txType = filters.txType;
  if (filters.asset) clean.asset = filters.asset;
  if (filters.dateFrom) clean.dateFrom = filters.dateFrom;
  if (filters.dateTo) clean.dateTo = filters.dateTo;
  if (filters.minAmount !== undefined && filters.minAmount !== null) clean.minAmount = filters.minAmount;
  if (filters.maxAmount !== undefined && filters.maxAmount !== null) clean.maxAmount = filters.maxAmount;
  if (filters.search) clean.search = filters.search;
  
  return clean;
};
